
import React, { Fragment } from 'react';

// Components

import HraDetails from './HraDetails';
import SummaryItem from '@components/ssap/pages/pageIncludes/summary/SummaryItem';
import SummaryFilter from '@components/ssap/pages/pageIncludes/summary/SummaryFilter';


// Constants

import { SsapSummaryType } from '@components/ssap/SsapTypes';

const HraInfo = props => {
    const {
        applicantGuid,
        healthReimbursementArrangement,
        householdMembers,
        idx,
        isFinalSummaryPage,
        isHealthReimbursementShown,
        isSsapInReviewMode,
        offeredIchraIndicator,
        previousData
    } = props;

    if (!isHealthReimbursementShown) {
        return null;
    }

    return (
        <Fragment>
            {
                offeredIchraIndicator === null
                    ? null
                    : (
                        <div className = 'grid-col-12' >
                            <div className = 'grid-row' >
                                <SummaryItem
                                    category = 'ssap.additional_info.summary.offered_hra'
                                    value = { offeredIchraIndicator }
                                    noPriorDataValues = { [ null ] }
                                    desc = {
                                        [
                                            [
                                                `taxHousehold.householdMember[${ idx }].healthCoverage.offeredIchraIndicator`
                                            ]
                                        ]
                                    }
                                />
                            </div>
                        </div>
                    )
            }
            {
                offeredIchraIndicator &&

                <SummaryFilter summaryId = { SsapSummaryType.HRA_DETAILS }>
                    <HraDetails
                        { ...{
                            applicantGuid,
                            healthReimbursementArrangement,
                            householdMembers,
                            isFinalSummaryPage,
                            isSsapInReviewMode,
                            previousData
                        } }
                    />
                </SummaryFilter>
            }
        </Fragment>
    );
};

export default HraInfo;